import React from 'react';
import { Link } from 'react-router-dom';
import './PoliticaCookies.css';

function PoliticaCookies() {
  return (
    <main className="cookie-policy">
      <article>
        <Link className="cookie-policy__back" to="/">← Voltar ao portal</Link>
        <h1>Privacidade e armazenamento no navegador</h1>
        <p className="cookie-policy__updated">Última atualização: 16 de setembro de 2026</p>

        <p>
          Esta política explica como o Portal de Inspeção utiliza o armazenamento do navegador,
          em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 — LGPD).
        </p>

        <h2>Como o portal mantém sua sessão</h2>
        <p>
          O portal utiliza o armazenamento local e de sessão do navegador para manter a autenticação,
          a segurança e os recursos necessários ao funcionamento do sistema. Não utiliza cookies de
          análise, publicidade ou rastreamento neste momento.
        </p>

        <h2>Tecnologias utilizadas</h2>
        <div className="cookie-policy__table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Nome ou dado</th>
                <th>Finalidade</th>
                <th>Categoria</th>
                <th>Prazo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dados de autenticação no navegador</td>
                <td>Manter o acesso, a segurança e o funcionamento da sessão.</td>
                <td>Necessário</td>
                <td>Até o logout, a expiração da sessão ou a remoção no navegador</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>Cookies opcionais</h2>
        <p>
          O portal não utiliza cookies opcionais, ferramentas de análise ou publicidade. Caso isso mude,
          esta política será atualizada e será apresentada uma opção específica para aceitar ou recusar
          as categorias não necessárias.
        </p>

        <h2>Como gerenciar seus dados no navegador</h2>
        <p>
          Você pode apagar os dados armazenados pelo portal diretamente nas configurações do navegador
          ou encerrar sua sessão por meio do botão de logout. Isso pode exigir um novo login, mas não
          impede o uso das funções essenciais do portal.
        </p>

        <h2>Seus direitos</h2>
        <p>
          Nos termos da LGPD, você pode solicitar informações sobre o tratamento, confirmação e acesso
          aos dados, correção, eliminação quando cabível, oposição e revogação do consentimento. Para
          exercer esses direitos ou tirar dúvidas, entre em contato com a Inguanti Inspeções pelo e-mail{' '}
          <a href="mailto:contato@inguanti.com.br">contato@inguanti.com.br</a> ou pelos telefones
          (11) 4654-4011 e (11) 98283-2778.
        </p>
      </article>
    </main>
  );
}

export default PoliticaCookies;
